import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import router from "./router";
import store from "./store";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import { i18n } from "./locale/index.js";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CountryFlag from "vue-country-flag";
import VueApexCharts from "vue-apexcharts";
import {ExportExcel} from "./mixins/ExportExce.js";
import "@/global.scss";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(VueApexCharts);
Vue.mixin(ExportExcel);
Vue.component("apexchart", VueApexCharts);

Vue.component("country-flag", CountryFlag);

Vue.component("loading-overlay", Loading);
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.prototype.$axios = axios;
// Vue.use(SnackBar)

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
